import React, { useContext, useState } from 'react';
import { ContainerContext } from '../../../../../context/ContainerContext';
import { CustomFieldContext } from '../../../../../context/CustomFieldContext';
import {
  ContainerMutations,
  UpdateContainerResponse,
  UpdateContainerVariables,
} from '../../../../../graphql/container.graphql';
import useMutation from '../../../../../hooks/useMutation';
import { useToast } from '../../../../../providers/ToastProvider';
import { Container, ContainerInput } from '../../../../../types/container';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { SaveChangesButton } from '../../../../components/Button';
import { ToastType } from '../../../../components/Toast';
import ContainerForm from './ContainerForm';
import { StockLocationRoleAssignmentContext } from '../../../../../context/StockLocationRoleAssignmentContext';
import { StockLocationRole } from '../../../../../types/stock_location_role_assignment';

interface UpdateContainerPaneProps {
  container: Container;
}

export default function UpdateContainerPane({ container }: UpdateContainerPaneProps) {
  const { showToast } = useToast();

  const { customFields } = useContext(CustomFieldContext);
  const { containers, setContainers } = useContext(ContainerContext);
  const { hasStockLocationRole } = useContext(StockLocationRoleAssignmentContext);

  const [input, setInput] = useState(new ContainerInput(container));

  const isSupervisor = hasStockLocationRole(
    input.companyId,
    input.stockLocationId || '',
    StockLocationRole.STOCK_LOCATION_SUPERVISOR,
  );

  const [update, { loading }] = useMutation<UpdateContainerResponse, UpdateContainerVariables>(
    ContainerMutations.update,
    {
      onCompleted: response => {
        const updated = response.updateContainer[0];
        setContainers(new Map(containers.set(updated.id, updated)));
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.containerUpdatedSuccessfullyToastTitle).singular.upper,
        });
      },
    },
  );

  return (
    <div className='content-x grid gap-8'>
      <ContainerForm input={input} setInput={setInput} />
      <div>
        {isSupervisor ? (
          <SaveChangesButton
            onClick={() => update({ variables: { containers: [input.forUpdate()] } })}
            loading={loading}
            disabled={!input.validate(customFields) || !input.hasChanges(container)}
          />
        ) : null}
      </div>
    </div>
  );
}
